
import { useState, useEffect } from 'react';

export function useVoiceCapability() {
  const [isVoiceEnabled, setIsVoiceEnabled] = useState(false);
  
  useEffect(() => {
    // Check if speech recognition is supported
    const isVoiceSupported = 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
    setIsVoiceEnabled(isVoiceSupported);
  }, []);

  return { isVoiceEnabled };
}
